/**
 * Budget spend with an end-of-day projection.
 *
 * The projection is the point. "4.6% used" at 01:00 is meaningless on its own;
 * "109% of cap by 22:00Z at the current rate" is a decision. The measured load
 * test projected 2,185,235 against a 2,000,000 cap, which is precisely the case
 * a raw percentage hides.
 */
import { Fragment } from 'react'
import { useBudget } from '../api/queries'
import { Bar, PanelState, Tile } from '../components/ui'
import { n, pct } from '../components/format'

export function Budget() {
  const { data, isLoading, error } = useBudget()
  return (
    <Tile title="Budget" hint="today · request-gated">
      <PanelState isLoading={isLoading} error={error}>
        <table className="t">
          <tbody>
            {data?.sources.map((s) => {
              const over = (s.projected_pct ?? 0) > 100
              return (
                // Fragment carries the key: it is the mapped element. Keying the
                // inner rows instead left the list item unkeyed, so React
                // reconciled by index.
                <Fragment key={s.source}>
                  <tr>
                    <td>{s.source}</td>
                    <td className="n">{n(s.used)}</td>
                    <td className="n q">/ {n(s.cap)}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>
                      <Bar pct={s.pct_used ?? 0} state={over ? 'warn' : 'ok'} />
                    </td>
                  </tr>
                  <tr>
                    <td className="q">projected EOD</td>
                    <td className="n" style={over ? { color: 'var(--crisis)' } : undefined}>
                      {n(s.projected_eod)}
                    </td>
                    <td className="n q">{pct(s.projected_pct)}</td>
                  </tr>
                </Fragment>
              )
            })}
          </tbody>
        </table>
      </PanelState>
    </Tile>
  )
}
